import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.rolle-benutzer';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRolleBenutzerEffects {

    RolleBenutzer$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ROLLE_BENUTZER),
        mergeMap((x: ac.GetRolleBenutzerAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getRolleBenutzer(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetRolleBenutzerErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetRolleBenutzerFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenQueryService);
        }
        return this.service;
    }
}
